"use strict";
import { useAccount } from "hooks/useAccount";
import { CONNECTION_PROVIDER_IDS } from "uniswap/src/constants/web3";
export function useIsUniExtensionAvailable() {
  const currentConnector = useAccount().connector;
  const currentConnectIsNotUniExtension = currentConnector && currentConnector.id !== CONNECTION_PROVIDER_IDS.UNISWAP_EXTENSION_RDNS;
  return !currentConnectIsNotUniExtension;
}
